import Image from '../common/Image';

// assets
import Logo from '../common/components/images/logo-slogan.svg';
import CoverImg from '../common/components/images/fondo.png';

// common component
import LayoutLogin from '../common/components/layout/LayoutLogin';
import FormLogin from './FormLogin';

const containerStyle = {
    width: '100%',
    height: '100vh',
};

const Login = (): JSX.Element => {
    return (
        <>
            <section className="relative" role="login">
                <div style={containerStyle} className="absolute z-10  opacity-80" />
                <div className="absolute z-50 w-full flex justify-center items-center" style={containerStyle}>
                    <div className="container mx-auto py-10 px-10 ms:px-40  bg-sm-blue-primary  sm:bg-opacity-50 sm:shadow-lg rounded-md w-full md:w-2/5">
                        <Image
                            className="mx-auto p-2 flex justify-center items-center"
                            src={Logo}
                            alt="SuperMatch - Juega donde y cuando quieras"
                            height={55}
                        />
                        <FormLogin origin={'login'} />
                    </div>
                </div>
            </section>
            <LayoutLogin navProps={{ title: 'Login | Supermatch', description: 'Supermatch' }}>
                <>
                    <Image
                        className="z-0"
                        src={CoverImg}
                        alt="Fondo"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="center"
                    />
                </>
            </LayoutLogin>
        </>
    );
};

export default Login;
